// feat-153 marketing-site launch — as-you-type formatter for the waitlist
// "Mobile number (optional)" input. The FORMATTED value is what gets POSTed, so
// the output must stay within the backend's accepted charset ([\d\s()+\-.]) and
// its VARCHAR(32) bound (routes/waitlist.py). US numbers render as
// "(555) 123-4567"; anything starting with "+" (international) passes through
// leniently (digits + spaces only) without forcing US grouping.

const MAX_LEN = 32;

export function formatMobile(raw: string): string {
  if (!raw) return '';

  // International: keep a leading "+", then allow only digits and single spaces.
  // Do not impose US grouping — users format their own country's number.
  if (raw.trimStart().startsWith('+')) {
    const rest = raw
      .trimStart()
      .slice(1)
      .replace(/[^\d\s]/g, '') // drop anything that isn't a digit or space
      .replace(/\s{2,}/g, ' '); // collapse runs of spaces
    return `+${rest}`.slice(0, MAX_LEN);
  }

  // US style: derive from digits only so backspacing/pasting stay consistent.
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';

  const head = digits.slice(0, 10);
  let out: string;
  if (head.length < 4) {
    out = `(${head}`;
  } else if (head.length < 7) {
    out = `(${head.slice(0, 3)}) ${head.slice(3)}`;
  } else {
    out = `(${head.slice(0, 3)}) ${head.slice(3, 6)}-${head.slice(6, 10)}`;
  }

  // More than 10 digits and no leading "+": likely a country code or extension —
  // append the overflow digits rather than silently dropping them.
  if (digits.length > 10) {
    out = `${out} ${digits.slice(10)}`;
  }

  return out.slice(0, MAX_LEN);
}
